
  import { mapState, mapActions } from 'vuex'
  import qs from 'qs'
  import { Dialog, Toast } from 'vant'


  export default {
    inject: ['reload'],
    data() {
      return {
        program: [],
        groupName: '',
        modal: false,
        button6: [{
          text: this.$t('append_field.cancel'),
          type: 'gray',
        }, {
          text: this.$t('append_field.confirm'),
        }],
        delObj: {
          id: '',
          index: 0,
        },
        groupId: 0,
        Pname: '',
        eventSign: 'click',
        contentTexe: this.$t('append_field.confirm_delete_program'),
        isVisible1: false,
        menuItems2: [],
        noData: true,

      }
    },
    mounted() {
      this.getprogram()
      this.groupName = this.$route.query.name
    },
    methods: {
      ...mapActions(['changeTopTitle', 'changeTopIconStatus', 'setParentPage']),
      getprogram() {
        this.$ajax.post('/etv/selectPhoneLstProgramMould.json', qs.stringify({
          pcId: this.$route.query.id,
          state: 0,
          pageSize: 12,
          pageNum: 1,
          name: '',
        })).then(res => {
          if (res.data.code === 0) {
            this.program = res.data.data
          }
        })
      },
      // eslint-disable-next-line no-unused-vars
      goto(url) {

      },

      gotoa(url, query) {
        this.$router.push({
          path: url,
          query,
        })
        if (url == '/addTask') {
          this.changeTopTitle(this.$t('append_field.addTask'))
          this.setParentPage('programs')
          this.changeTopIconStatus(true)
        }
      },

      // delprogram(id, index, number) {
      delprogram(id,index,num) {
        if(!parseInt(num)){
          this.delObj.id = id
          this.deleteConfirm()
          return
        }
        let _this = this
        _this.isVisible1 = true
        _this.delObj.id = id
        this.$ajax.post('/etv/selectProgramMouldBindEqtask.json',qs.stringify({
          id: id
        })).then(res => {
          if(res.data.data.length > 0){
            _this.noData = false
            _this.menuItems2 = res.data.data
          }else{
            _this.noData = true
          }
        })

      },
      deleteConfirm(){
          let contentTexe = this.$t('append_field.confirm_delete_this_program')
          this.isVisible1 = false
          // if (number !== 0) {
          //   contentTexe = this.$t('append_field.bound_tasks_exists_confirm_delete')
          // } else {
          //   contentTexe = this.$t('append_field.confirm_delete_program')
          // }
          // this.delObj = {
          //   id,
          //   index,
          // }


          Dialog.confirm({
            title: this.$t('append_field.prompt'),
            message: contentTexe,
          }).then(() => {
            this.$ajax.post('/etv/deleteProgramMouldById.json', qs.stringify({
              id: this.delObj.id,
            })).then(res => {
              if (res.data.code === 0) {
                Toast(this.$t('append_field.delete_success'))
                this.reload()
              } else {
                Toast(this.$t('append_field.delete_failed'))
              }
            })
          }).catch(() => {
            // on cancel
          })
      },
      hide() {
        this.modal = false
      },

    },
    computed: {
      ...mapState({
        progranList: state => state.progranList,
      }),
    },
  }
